import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import Image from "next/image";
import IMAGES from "images";
import { useEffect } from "react";
import { useState } from "react";
import { handleScrollLeft, handleScrollRight } from "redux-share/actions";
import dynamic from "next/dynamic";

const SinglePlayList = dynamic(() => import("./singlePlayList"));

interface PlaylistVideoCards {
    onClick: (playlistId:number)=> void,
    playList: any,
    videoPlaylist: any,
    selectedPlaylist: number,
    scrollEnd: boolean
}

const PlayListVideoCards = (props: PlaylistVideoCards) => {

    const [isHover, setIsHover] = useState<boolean>(false);
    const [isScrollable, setIsScrollable] = useState<boolean>(true);

    useEffect(() => {
        if (document.getElementById("playlistTab") && conditions(ConditionName.isComplexDesktop)) handleScroll();
    }, [document.getElementById("playlistTab")])

    const handleScroll = () => setIsScrollable(!!document.getElementById("playlistTab") && Math.abs(Math.abs(document.getElementById("playlistTab")!.scrollWidth) - (document.getElementById("playlistTab")!.getBoundingClientRect().width + Math.abs(document.getElementById("playlistTab")!.scrollLeft))) <= 1)

    return (
        <>
            <div className={`pl-flex pl-flex-col pl-gap-2`}>
              <div className="pl-relative pl-flex pl-flex-col pl-mx-4" onMouseOut={() => setIsHover(false)} onMouseOver={() => setIsHover(true)}>
                {conditions(ConditionName.isComplexDesktop) && isHover && !isScrollable && (
                    <div className="pl-flex pl-absolute pl-left-0 bg-red-500" onClick={(event:any) => handleScrollLeft(event,"playlistTab")} style={{width: 10, height: 10}}>
                        <Image
                            src={conditions(ConditionName.isDarkMode) ? IMAGES.rightArrow : IMAGES.lightRightArrow}
                            className={`pl-cursor-pointer pl-h-full pl-w-full`}
                            layout={"fill"}
                            alt="right-arrow"
                        />
                    </div>
                )}

                <div className="pl-flex pl-w-full pl-items-center no-scrollbar pl-overflow-auto pl-gap-10" id={"playlistTab"}>
                    {
                        props.playList.length > 1 ? props.playList.map((item:any)=>{
                            return (
                            <div onClick={() => props.onClick(item.id)} className={`${item.id === props.selectedPlaylist ? "!pl-text-z-gray-800 dark:!pl-text-white" : "!pl-text-[#939598]"} !pl-whitespace-nowrap pl-w-fit pl-cursor-pointer pl-text-[14px] pl-font-[700] pl-text-secondary-900 dark:pl-text-secondary-50`}>
                                {item.title}
                                {item.id === props.selectedPlaylist && <div className="dark:pl-bg-white pl-w-full pl-h-[3px] pl-bg-gray-800 pl-rounded-t-[4px]"/>}
                            </div>
                            )
                        }) : <></>
                    }
                </div>
                {
                conditions(ConditionName.isComplexDesktop) && isHover && !isScrollable &&
                <div className="pl-flex pl-absolute pl-right-0" onClick={(event:any) => handleScrollRight(event,"playlistTab")} style={{
                    width: 10, height: 10
                }}>
                    <Image
                        src={conditions(ConditionName.isDarkMode) ? IMAGES.leftArrow : IMAGES.lightLeftArrow}
                        className={`pl-cursor-pointer pl-h-full pl-w-full`}
                        layout={"fill"}
                        alt="left-arrow"
                    />
                </div>
            }
                {props.playList.length > 1 && <hr/>}
              </div>
                <div className="pl-flex pl-flex-col pl-gap-2">
                    {(props.videoPlaylist !== undefined) && <SinglePlayList playList={{title: (props.playList.map((item:any)=> item.id === props.selectedPlaylist) as any).title, videos: props.videoPlaylist}}/>}
                    {/* {(props.scrollEnd || props.videoPlaylist === undefined) && Array.from(Array(4).keys()).map((item)=> <Skeleton key={item}/>)} */}
                </div>
            </div>
        </>
    )
}

export default PlayListVideoCards;